/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#nameuser[_ngcontent-%COMP%]{color:#fafad2;text-shadow:2px 2px 2px #000}#botonhome[_ngcontent-%COMP%]{text-shadow:2px 2px 2px #000}.navbar[_ngcontent-%COMP%]{position:fixed;top:0;width:100%;z-index:9999}.navbar[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{margin-bottom:0}\n/*# sourceMappingURL=navbar.component.css.map*/"];
export { styles as styles };
